import { AB_CREATIVE_EXTENSION } from "@/constants/ABMng";
import { type IABData } from "@/utils/hooks/useABtest";

interface IAbClientData {
  data: {
    variableValue: string;
    variableName: string;
    experimentId: string;
    experimentUrls: string[];
    id: string;
    versionId: string;
    eventIds: number[];
  }[];
  experimentSign: {
    [key: string]: {
      variable: {
        [key: string]: string;
      }[];
      sign: string;
    };
  }[];
}

export function getABTestFlag<T extends Record<string, string | string[]>>(
  abClientData: IAbClientData,
  config: IABData<T>
) {
  const value = getABTestFlagValue(abClientData, config);

  const map = config.map || {};

  return Object.entries(map || {}).reduce(
    (result, item) => {
      if (Array.isArray(item[1])) {
        result[item[0]] = (item[1] as string[]).includes(value as string);
      } else {
        result[item[0]] = value === item[1];
      }
      return result;
    },
    {
      value,
    }
  ) as Record<keyof T, boolean> & { value: string };
}

export function getABTestFlagValue<T extends Record<string, string | string[]>>(
  abClientData: IAbClientData,
  config: IABData<T>
) {
  const { data } = abClientData || {};
  const { defaultValue, variableName } = config;

  const flag = data?.find((item) => item.variableName === variableName);

  const value = flag?.variableValue || defaultValue;

  return value;
}

/**
 * 服务端获取全局AB实验值，放到Context中，供应用获取全局AB实验值
 * @param abClientData
 * @param isPageCache
 * @returns
 */
export function getGlobalFlag(
  abClientData: IAbClientData,
  isPageCache: boolean
) {
  // 带有页面缓存页面的不获取，不然会被页面缓存掉，导致AB实验值不准确
  return isPageCache
    ? null
    : {
        [AB_CREATIVE_EXTENSION.variableName]:
          getABTestFlagValue(abClientData, AB_CREATIVE_EXTENSION) || null,
      };
}
